import { WebAgent } from "./WebAgent";

export abstract class ImageResize {
  static async ImageReader(image: File): Promise<any> {
    return new Promise((resolve, rejected) => {
      let reader = new FileReader();
      reader.onload = (e: any) => {
        resolve(e.target.result);
      };
      reader.readAsDataURL(image);
    });
  }
  static async Resize(file: File): Promise<File> {
    return new Promise(async (resolve, rejected) => {
      let { name } = file;
      name = name.split(".")[0];
      let context = null;
      let imageData = null;
      let maxWidth = 1024;
      let maxHeigt = 768;
      let width = maxWidth;
      let height = maxHeigt;
      let newFile: File = null;

      var img = document.createElement("img");
      var canvas = document.createElement("canvas");
      img.src = await this.ImageReader(file);

      img.onerror = e => rejected(e);
      img.onload = () => {
        // draw
        context = canvas.getContext("2d");
        context.drawImage(img, 0, 0);
        if (img.width > maxWidth || img.height > maxHeigt) {
          width = maxWidth;
          height = maxHeigt;

          if (img.width > maxWidth) {
            width = maxWidth;
            var ration = maxWidth / img.width;
            height = Math.round(img.height * ration);
          }

          if (img.height > maxHeigt) {
            height = maxHeigt;
            var ration = maxHeigt / img.height;
            width = Math.round(img.width * ration);
          }
        } else {
          width = img.width;
          height = img.height;
        }
        canvas.width = width;
        canvas.height = height;

        context.drawImage(img, 0, 0, width, height);
        imageData = canvas.toDataURL("image/jpeg");
        imageData.replace("data:image/jpeg;base64,", "");

        let blobToFile = this.dataURItoBlob(imageData);
        if (WebAgent.IsInternetExplore()) {
          newFile = Object.assign(blobToFile, {
            name: name + ".jpg",
            lastModified: Date.now(),
            type: "image/jpeg"
          });
        } else {
          newFile = new File([blobToFile], name + ".jpg", {
            type: "image/jpeg",
            lastModified: Date.now()
          });
        }

        resolve(newFile);
      };
    });
  }
  static dataURItoBlob(dataURI) {
    // convert base64 to raw binary data held in a string
    var byteString = atob(dataURI.split(",")[1]);
    // separate out the mime component
    var mimeString = dataURI
      .split(",")[0]
      .split(":")[1]
      .split(";")[0];
    // write the bytes of the string to an ArrayBuffer
    var arrayBuffer = new ArrayBuffer(byteString.length);
    var _ia = new Uint8Array(arrayBuffer);
    for (var i = 0; i < byteString.length; i++) {
      _ia[i] = byteString.charCodeAt(i);
    }
    var dataView = new DataView(arrayBuffer);
    var blob = new Blob([dataView], { type: mimeString });
    return blob;
  }
}
